import { render, staticRenderFns } from "./ContentNotice.vue?vue&type=template&id=1315520f&"
import script from "./ContentNotice.vue?vue&type=script&lang=js&"
export * from "./ContentNotice.vue?vue&type=script&lang=js&"
import style0 from "./ContentNotice.vue?vue&type=style&index=0&id=1315520f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports